import {exampleApi} from '@/infrastructure/Configuration'

export default class ExampleService {
    constructor(httpClient) {
        this.httpClient = httpClient
    }

    async getExampleList() {
        const url = `${exampleApi}/endPoint/GetExampleList`
        const response = await this.httpClient.get(url)
        return response.data;
    }

    async getExampleListById(id) {
        const url = `${exampleApi}/endPoint/getExampleListById`
        const response = await this.httpClient.get(url, {params: {id}})
        return response.data;
    }

    async postExample(data) {
        const url = `${exampleApi}/endPoint/postExample`
        const response = await this.httpClient.post(url, data)
        return response.data
    }

}
